<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Transaction Details
              <div class="spinner-border spinner-border-sm text-primary" v-show="transctionDetailLoading"></div>
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="form form-horizontal mt-2" >
              <div class="row">
                <div class="col-12">
                  <section  class="invoice-preview-wrapper" v-if="transactionDetails && !isEmpty(transactionDetails)">
                    <div class="row invoice-preview">
                      <!-- Invoice -->
                      <div class="col-12">
                        <div class="card invoice-preview-card">
                          <div class="card-body invoice-padding pb-0">
                            <!-- Header starts -->
                            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                              <div>
                                <div class="logo-wrapper">
                                  <h3><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h3>
                                </div>
                                <p class="card-text mb-25">Payment Method: {{ transactionDetails.payment_method?transactionDetails.payment_method.name:'N/A' }}</p>
                                <p class="card-text mb-25">Gateway Ref Id:
                                  {{ transactionDetails.gateway_reference_id ? transactionDetails.gateway_reference_id : 'N/A' }}</p>
                                <p class="card-text mb-25">Ref Id:
                                  {{ transactionDetails.reference_id ? transactionDetails.reference_id : 'N/A' }}</p>
                                <p class="card-text mb-0">Transaction Type: {{ transactionDetails.transaction_type? transactionDetails.transaction_type.name:'N/A' }}</p>
                                <p class="card-text mb-0" v-if="transactionDetails.settlement_status == 1">Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-info">INITIATED</span></p>
                                <p class="card-text mb-0" v-else-if="transactionDetails.settlement_status == 2">Settlement Status: <span class="badge badge-pill mt-1  badge-glow badge-danger">CANCELED</span></p>
                                <p class="card-text mb-0" v-else-if="transactionDetails.settlement_status == 3">Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-success">DONE</span></p>
                                <p class="card-text mb-0" v-else>Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-warning">PENDING</span></p>

                                <p class="card-text mb-25" v-if="transactionDetails.status == 1">Transaction Status:  <span class="badge  mt-1  badge-glow badge-info">Success</span></p>
                                <p class="card-text mb-25" v-else-if="transactionDetails.status == 2">Transaction Status: <span class="badge  mt-1  badge-glow badge-danger">Failed</span></p>
                                <p class="card-text mb-25" v-else> Transaction Status:  <span class="badge  mt-1  badge-glow badge-warning">PENDING</span></p>
                                <p class="card-text mb-25 mt-1">Aquiring: {{ transactionDetails.aquiring?transactionDetails.aquiring.name+'/'+transactionDetails.aquiring.code:'N/A' }}</p>
                                <p class="card-text mb-25 mt-1">Schema: {{ transactionDetails.schema?transactionDetails.schema.name+'/'+transactionDetails.schema.code:'N/A' }}</p>
                                <p class="card-text mb-25 mt-1">Channel: {{ transactionDetails.channel?transactionDetails.channel.name+'/'+transactionDetails.channel.code:'N/A' }}</p>
                                <p class="card-text mb-25 mt-1">Country: {{ transactionDetails.country_code?transactionDetails.country_code:'N/A' }}</p>
                                <p class="card-text mb-25 mt-1">Approval Code: {{ transactionDetails.approval_code?transactionDetails.approval_code:'N/A' }}</p>
                                <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.ip_address) != 'undefined'">IP Address: {{  transactionDetails.ip_address?transactionDetails.ip_address:'N/A' }}</p>
                                <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.client_reference) != 'undefined'">Client Reference: {{ transactionDetails.client_reference?transactionDetails.client_reference:'N/A' }}</p>
                                <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.payment_link) != 'undefined'">Callback Url: {{ transactionDetails.payment_link?(transactionDetails.payment_link.callback_url && transactionDetails.payment_link.callback_url != ''?transactionDetails.payment_link.callback_url:'N/A') :'N/A' }}</p>
                                <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.payment_link) != 'undefined'">Redirect Url: {{ transactionDetails.payment_link?(transactionDetails.payment_link.redirect_url && transactionDetails.payment_link.redirect_url != ''?transactionDetails.payment_link.redirect_url:'N/A') :'N/A' }}</p>
                              </div>
                              <div class="mt-md-0 mt-2">
                                <h4 class="invoice-title mb-0">
                                  Transaction
                                  <span class="invoice-number">#{{this.transactionId}}</span>
                                </h4>
                                <h6 v-if="transactionDetails.application == 'DIRECT_API_PAYMENT'" class="invoice-title ">
                                  <span class="badge badge-light-info">Direct Api Payment</span>
                                </h6>
                                <div class="invoice-date-wrapper justify-content-end">
                                  <p class="invoice-date-title">Date Created:</p>
                                  <p class="invoice-date">{{
                                      new Date(transactionDetails.created_at).toISOString().slice(0, 16).replace('T', ' ')
                                    }}</p>

                                </div>
                                <div class="justify-content-end d-flex" v-if="transactionDetails.process_manually_by">
                                  <p class=""><span class="badge badge-success">Processed Manually</span></p>
                                </div>
                              </div>
                            </div>
                            <!-- Header ends -->
                          </div>

                          <hr class="invoice-spacing mt-0" v-if="showAdjustmentDescription(transactionDetails)" />

                          <div class="card-body invoice-padding py-0" v-if="showAdjustmentDescription(transactionDetails)">
                            <!-- Invoice Note starts -->
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group mb-2">
                                  <label  class="form-label font-weight-bold text-primary">Adjustment Description:</label>
                                  <textarea disabled="true" class="form-control" rows="2" >
                          {{transactionDetails.other_details.description}}
                        </textarea>
                                </div>
                              </div>
                            </div>
                            <!-- Invoice Note ends -->
                          </div>

                          <hr class="invoice-spacing"/>


                          <div class="card-body invoice-padding pt-0">
                            <div class="row invoice-spacing">
                              <div class="col-xl-8 p-0">
                                <h6 class="mb-2">Sender Details:</h6>
                                <h6 class="mb-25">Name: {{transactionDetails.sender.first_name + ' '+ transactionDetails.sender.last_name }}</h6>
                                <p class="card-text mb-25">Email: {{transactionDetails.sender.email}} </p>
                                <p class="card-text mb-25">Account title: {{transactionDetails.sender_account_title}}</p>
                                <p class="card-text mb-25">Account Number: {{transactionDetails.sender_account_number}}</p>
                                <p class="card-text mb-25">Customer Email: {{transactionDetails.customer?transactionDetails.customer.email:'N/A'}}</p>
                                <p class="card-text mb-25">Customer Name: {{transactionDetails.customer?transactionDetails.customer.name:'N/A'}}</p>
                                <p class="card-text mb-25">Customer Phone: {{transactionDetails.customer?transactionDetails.customer.phone:'N/A'}}</p>
                              </div>
                              <div class="col-xl-4 p-0 mt-xl-0 mt-2">
                                <h6 class="mb-2">Receiver Details:</h6>
                                <h6 class="mb-25">Name: {{transactionDetails.receiver.first_name + ' '+ transactionDetails.receiver.last_name }}</h6>
                                <p class="card-text mb-25">Email: {{transactionDetails.receiver.email}} </p>
                                <p class="card-text mb-25">Account title: {{transactionDetails.receiver_account_title}}</p>
                                <p class="card-text mb-25">Account Number: {{transactionDetails.receiver_account_number}}</p>
                              </div>
                            </div>
                          </div>


                          <div class="card-body invoice-padding pb-0 mt-5">
                            <div class="row invoice-sales-total-wrapper">
                              <div class="col-md-4 order-md-1 order-2 mt-md-0 mt-3">

                              </div>
                              <div class="col-md-8 d-flex justify-content-end order-md-2 order-1">
                                <div class="invoice-total-wrapper">
                                  <div class="invoice-total-item">
                                    <p class="invoice-total-title">Actual Amount:</p>
                                    <p class="invoice-total-amount" v-if="transactionDetails.amount != transactionDetails.total_amount">{{ parseFloat(transactionDetails.total_amount / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                    <p class="invoice-total-amount" v-else>{{ parseFloat(transactionDetails.amount / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                  </div>
                                  <div class="invoice-total-item">
                                    <p class="invoice-total-title">Vat:</p>
                                    <p class="invoice-total-amount">
                                      {{ parseFloat(transactionDetails.vat / 100).toFixed(feesDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                  </div>
                                  <div class="invoice-total-item">
                                    <p class="invoice-total-title">Fee:</p>
                                    <p class="invoice-total-amount">
                                      {{ parseFloat(transactionDetails.fee / 100).toFixed(feesDecimalPlaces)+ ' ' + transactionDetails.currency.code  }}</p>
                                  </div>
                                  <hr class="my-50"/>
                                  <div class="invoice-total-item">
                                    <p class="invoice-total-title">Payable Amount:</p>
                                    <p class="invoice-total-amount text-danger" v-if="transactionDetails.transaction_type_id == 6">- {{parseFloat((parseFloat(transactionDetails.amount)+parseFloat(transactionDetails.vat)+parseFloat(transactionDetails.fee))/100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code }}</p>
                                    <p class="invoice-total-amount" v-else-if="transactionDetails.amount != transactionDetails.total_amount">{{ parseFloat((transactionDetails.amount) / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                    <p class="invoice-total-amount" v-else>{{ parseFloat((transactionDetails.amount - transactionDetails.vat - transactionDetails.fee) / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          <hr class="invoice-spacing"/>


                        </div>
                      </div>
                      <!-- /Invoice -->

                    </div>
                  </section>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'transactionId', 'index'],
  mounted() {

  },
  data() {
    return {
      transactionDetails:[],
      transctionDetailLoading:false
    };
  },
  methods: {
    showAdjustmentDescription(transactions){
      if(transactions.other_details){
        if(typeof(transactions.other_details.description) != 'undefined'){
          if(transactions.other_details.description != ''){
            return true
          }
        }
      }

      return false
    },
    getTransactionsDetails() {
      this.transctionDetailLoading = true
      let data = {
        transactionId: this.transactionId,
        transactionDetail: 1
      }
      this.makeRequest("post", "v1/get-transaction", data, {}, false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.transactionDetails = responseData
              }
            }
            this.transctionDetailLoading = false
          }
      );
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.getTransactionsDetails()
      } else {
        this.$nextTick(() => {
          this.transactionDetails = []
        })
      }

    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>
